import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableVehicleRoutes = Loadable(
  './VehicleRoutes',
  () => import(/* webpackChunkName: "Vehicle" */ './VehicleRoutes'),
  () => [(require as any).resolveWeak('./VehicleRoutes')]
);
